export default __webpack_public_path__ + "static/media/sweet3.e2c0e7fb.png";